module.exports = __webpack_public_path__ + "img/20210419225648113boc.52b9aba0.png";